export default __webpack_public_path__ + "metamask-round.aa9704a.svg";